import { render, staticRenderFns } from "./BaseLoadingIcon.vue?vue&type=template&id=cb936996&scoped=true&"
import script from "./BaseLoadingIcon.vue?vue&type=script&lang=js&"
export * from "./BaseLoadingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb936996",
  null
  
)

export default component.exports